import { render } from "./paypalBtn.vue?vue&type=template&id=9202133a&scoped=true"
import script from "./paypalBtn.vue?vue&type=script&lang=js"
export * from "./paypalBtn.vue?vue&type=script&lang=js"

import "./paypalBtn.vue?vue&type=style&index=0&id=9202133a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9202133a"]])

export default __exports__